// extracted by mini-css-extract-plugin
module.exports = {"form":"FuelDiscountForm_form__14kW7"};